<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>Follow-ups</h2>
        <p>Review scheduled callbacks and conversation notes.</p>
      </div>
    </div>

    <div class="lead-filters">
      <div class="lead-filter-field">
        <label>Search</label>
        <input [(ngModel)]="filters.search" placeholder="Customer / phone / notes" />
      </div>
      <div class="lead-filter-field">
        <label>Follow-up Date</label>
        <p-datepicker
          [(ngModel)]="filters.date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          inputId="follow-up-filter-date"
          [showOnFocus]="true"
          [showButtonBar]="true"
          [readonlyInput]="true">
        </p-datepicker>
      </div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn-secondary" (click)="applyFilters()">Apply Filters</button>
      <button class="lead-btn-muted filter-reset-btn" (click)="resetFilters()">Reset</button>
    </div>

    <div class="lead-loading" *ngIf="loading">Loading follow-ups...</div>

    <div class="lead-table-wrap" *ngIf="!loading">
      <table class="lead-table">
        <thead>
          <tr>
            <th>Lead ID</th>
            <th>Customer</th>
            <th>Phone</th>
            <th>Type</th>
            <th>Follow-up Date</th>
            <th>Next Follow-up</th>
            <th>Notes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!followUps.length">
            <td colspan="8" class="lead-empty">No follow-ups found.</td>
          </tr>
          <tr *ngFor="let followUp of followUps">
            <td>{{ followUp.lead_id_display }}</td>
            <td>{{ followUp.customer_name }}</td>
            <td>{{ followUp.phone_number }}</td>
            <td>{{ followUp.follow_up_type }}</td>
            <td>{{ followUp.follow_up_date }}</td>
            <td>{{ followUp.next_follow_up_date || '-' }}</td>
            <td>{{ followUp.notes || '-' }}</td>
            <td class="table-actions-cell">
              <div class="table-actions">
                <button class="action-button bt-edit" (click)="openEdit(followUp)" title="Edit Follow-up" aria-label="Edit Follow-up">
                  <fa-icon [icon]="['fas', 'pen']"></fa-icon>
                </button>
                <button class="action-button bt-delete" (click)="deleteFollowUp(followUp)" title="Delete Follow-up" aria-label="Delete Follow-up">
                  <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="follow-up-page-size">Records per page</label>
        <select id="follow-up-page-size" [(ngModel)]="pageSize" (change)="selectPageSize()">
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m15 18-6-6 6-6"/></svg>
        </button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m9 18 6-6-6-6"/></svg>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="lead-modal-backdrop" *ngIf="showEditModal">
  <div class="lead-modal">
    <div class="lead-title">
      <h3>Edit Follow-up</h3>
      <p>{{ selectedFollowUp?.customer_name }}</p>
    </div>
    <div class="lead-form-grid">
      <div class="lead-form-field">
        <label>Follow-up Type</label>
        <select [(ngModel)]="followUpForm.follow_up_type">
          <option *ngFor="let type of followUpTypes" [value]="type[0]">{{ type[1] }}</option>
        </select>
      </div>
      <div class="lead-form-field">
        <label>Follow-up Date</label>
        <p-datepicker
          [(ngModel)]="followUpForm.follow_up_date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          inputId="follow-up-edit-date"
          [showOnFocus]="true"
          [showButtonBar]="true"
          [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-form-field">
        <label>Next Follow-up Date</label>
        <p-datepicker
          [(ngModel)]="followUpForm.next_follow_up_date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          inputId="follow-up-edit-next-date"
          [showOnFocus]="true"
          [showButtonBar]="true"
          [readonlyInput]="true">
        </p-datepicker>
      </div>
      <div class="lead-form-field" style="grid-column: 1 / -1;">
        <label>Notes</label>
        <textarea [(ngModel)]="followUpForm.notes"></textarea>
      </div>
    </div>
    <div class="inline-actions">
      <button class="lead-btn" (click)="saveFollowUp()">Save Follow-up</button>
      <button class="lead-btn-muted" (click)="showEditModal = false">Cancel</button>
    </div>
  </div>
</div>
